export default {
  'app.settings.menuMap.basic': 'Basic Settings',
  'app.settings.menuMap.security': 'Security Settings',
  'app.settings.menuMap.binding': 'Account Binding',
  'app.settings.menuMap.notification': 'New Message Notification',
  'app.settings.basic.avatar': 'Avatar',
  'app.settings.basic.change-avatar': 'Change avatar',
  'app.settings.basic.email': 'Email',
  'app.settings.basic.email-message': 'Please input your email!',
  'app.settings.basic.nickname': 'Nickname',
  'app.settings.basic.nickname-message': 'Please input your Nickname!',
  'app.settings.basic.profile': 'Personal profile',
  'app.settings.basic.profile-message': 'Please input your personal profile!',
  'app.settings.basic.profile-placeholder': 'Brief introduction to yourself',
  'app.settings.basic.country': 'Country/Region',
  'app.settings.basic.country-message': 'Please input your country!',
  'app.settings.basic.geographic': 'Province or city',
  'app.settings.basic.geographic-message': 'Please input your geographic info!',
  'app.settings.basic.address': 'Street Address',
  'app.settings.basic.address-message': 'Please input your address!',
  'app.settings.basic.phone': 'Phone Number',
  'app.settings.basic.phone-message': 'Please input your phone!',
  'app.settings.basic.update': 'Update Information',
  'app.settings.security.strong': 'Strong',
  'app.settings.security.medium': 'Medium',
  'app.settings.security.weak': 'Weak',
  'app.settings.security.password': 'Account Password',
  'app.settings.security.password-description': 'Current password strength',
  'app.settings.security.phone': 'Security Phone',
  'app.settings.security.phone-description': 'Bound phone',
  'app.settings.security.question': 'Security Question',
  'app.settings.security.question-description':
    'The security question is not set, and the security policy can effectively protect the account security',
  'app.settings.security.email': 'Backup Email',
  'app.settings.security.email-description': 'Bound Email',
  'app.settings.security.mfa': 'MFA Device',
  'app.settings.security.mfa-description':
    'Unbound MFA device, after binding, can be confirmed twice',
  'app.settings.security.modify': 'Modify',
  'app.settings.security.set': 'Set',
  'app.settings.security.bind': 'Bind',
  'app.settings.binding.taobao': 'Binding Taobao',
  'app.settings.binding.taobao-description': 'Currently unbound Taobao account',
  'app.settings.binding.alipay': 'Binding Alipay',
  'app.settings.binding.alipay-description': 'Currently unbound Alipay account',
  'app.settings.binding.dingding': 'Binding DingTalk',
  'app.settings.binding.dingding-description':
    'Currently unbound DingTalk account',
  'app.settings.binding.bind': 'Bind',
  'app.settings.notification.password': 'Account Password',
  'app.settings.notification.password-description':
    'Messages from other users will be notified in the form of a station letter',
  'app.settings.notification.messages': 'System Messages',
  'app.settings.notification.messages-description':
    'System messages will be notified in the form of a station letter',
  'app.settings.notification.todo': 'To-do Notification',
  'app.settings.notification.todo-description':
    'The to-do list will be notified in the form of a letter from the station',
  'app.settings.open': 'Open',
  'app.settings.close': 'Close',
  'kg.settings.pageSubtitle':
    'Manage default behavior, display strategy, extraction rules, and governance thresholds for the platform knowledge graph.',
  'kg.settings.navLabel': 'Setting groups',
  'kg.settings.pageEyebrow': 'Platform knowledge graph settings',
  'kg.settings.noticeTitle':
    'Changes apply directly to platform-level graph settings',
  'kg.settings.noticeDescription':
    'Save by section whenever possible. If you switch sections with unsaved changes, the page will ask whether to continue editing or discard them.',
  'kg.settings.lastUpdated': 'Last updated',
  'kg.settings.sections.basic.title': 'Basic settings',
  'kg.settings.sections.basic.description':
    'Configure the default view, default types, and default query scope.',
  'kg.settings.sections.basic.intro':
    'These settings define the default working context when administrators enter the graph workspace for the first time.',
  'kg.settings.sections.display.title': 'Display strategy',
  'kg.settings.sections.display.description':
    'Control layout, density, and summary visibility across the graph canvas.',
  'kg.settings.sections.display.intro':
    'Display strategy keeps the browsing experience stable so different admins see the same graph with consistent defaults.',
  'kg.settings.sections.extraction.title': 'Extraction and review',
  'kg.settings.sections.extraction.description':
    'Manage AI extraction model defaults, thresholds, and review gates.',
  'kg.settings.sections.extraction.intro':
    'Extraction rules decide whether imports trigger recognition automatically and when results can pass without manual review.',
  'kg.settings.sections.governance.title': 'Governance defaults',
  'kg.settings.sections.governance.description':
    'Define default rules for deduplication, import handling, and system-type protection.',
  'kg.settings.sections.governance.intro':
    'Governance defaults affect bulk imports, entity deduplication, and the editable boundaries of built-in system types.',
  'kg.settings.actions.restoreDefaults': 'Restore platform defaults',
  'kg.settings.actions.cancel': 'Cancel',
  'kg.settings.actions.discard': 'Discard changes',
  'kg.settings.actions.continueEditing': 'Continue editing',
  'kg.settings.actions.resetSection': 'Reset current section',
  'kg.settings.actions.saveSection': 'Save current section',
  'kg.settings.messages.loadFailed':
    'Failed to load settings. Please try again later.',
  'kg.settings.messages.leaveTitle': 'This section has unsaved changes',
  'kg.settings.messages.leaveContent':
    'Before switching sections, decide whether to continue editing or discard the current unsaved changes.',
  'kg.settings.messages.saveFailed':
    'Failed to save settings. Please try again later.',
  'kg.settings.messages.resetTitle': 'Restore platform defaults?',
  'kg.settings.messages.resetContent':
    'Restoring defaults will overwrite the saved configuration for all sections. Make sure the reset will not affect current operations.',
  'kg.settings.messages.resetSuccess':
    'Platform knowledge graph settings restored to defaults',
  'kg.settings.messages.resetFailed':
    'Failed to restore defaults. Please try again later.',
  'kg.settings.messages.basicSaved': 'Basic settings saved',
  'kg.settings.messages.displaySaved': 'Display strategy saved',
  'kg.settings.messages.extractionSaved':
    'Extraction and review settings saved',
  'kg.settings.messages.governanceSaved': 'Governance defaults saved',
  'kg.settings.fields.defaultViewName': 'Default graph view name',
  'kg.settings.fields.defaultSearchScope': 'Default query scope',
  'kg.settings.fields.defaultEntityType': 'Default entity type',
  'kg.settings.fields.defaultRelationType': 'Default relation type',
  'kg.settings.fields.autoExpandRelatedEntities':
    'Auto-expand related entities',
  'kg.settings.fields.defaultLayout': 'Default layout algorithm',
  'kg.settings.fields.nodeDensity': 'Node density mode',
  'kg.settings.fields.showRelationLabels': 'Show relation labels',
  'kg.settings.fields.enableNodeAggregation': 'Enable node aggregation',
  'kg.settings.fields.showPropertySummary': 'Show property summary panel',
  'kg.settings.fields.highlightPathOnHover': 'Highlight paths on hover',
  'kg.settings.fields.modelProvider': 'Default extraction model',
  'kg.settings.fields.promptStrategy': 'Prompt strategy',
  'kg.settings.fields.confidenceThreshold': 'Confidence threshold',
  'kg.settings.fields.autoApproveThreshold': 'Auto-approve threshold',
  'kg.settings.fields.autoExtractOnImport': 'Trigger extraction after import',
  'kg.settings.fields.requireManualReview':
    'Require manual review below auto-approve',
  'kg.settings.fields.enableRiskBlocking': 'Enable risk blocking',
  'kg.settings.fields.deduplicationMode': 'Default deduplication mode',
  'kg.settings.fields.defaultSourceStatus': 'Default status for new data',
  'kg.settings.fields.maxImportBatchSize': 'Max items per import batch',
  'kg.settings.fields.enableChangeAudit': 'Enable change audit',
  'kg.settings.fields.lockSystemTypes': 'Lock built-in system types',
  'kg.settings.placeholders.defaultViewName':
    'For example: Platform graph overview',
  'kg.settings.placeholders.defaultEntityType': 'Select a default entity type',
  'kg.settings.placeholders.defaultRelationType':
    'Select a default relation type',
  'kg.settings.validation.defaultViewName':
    'Please enter a default graph view name',
  'kg.settings.options.scope.platform': 'Platform',
  'kg.settings.options.scope.tenant': 'Tenant',
  'kg.settings.options.layout.force': 'Force',
  'kg.settings.options.layout.radial': 'Radial',
  'kg.settings.options.layout.dagre': 'Layered',
  'kg.settings.options.density.comfortable': 'Comfortable',
  'kg.settings.options.density.balanced': 'Balanced',
  'kg.settings.options.density.compact': 'Compact',
  'kg.settings.options.prompt.balanced': 'Balanced',
  'kg.settings.options.prompt.strict': 'Strict',
  'kg.settings.options.prompt.aggressive': 'Aggressive',
  'kg.settings.options.deduplication.manual': 'Manual review',
  'kg.settings.options.deduplication.semiAuto': 'Semi-automatic merge',
  'kg.settings.options.deduplication.strict': 'Strict deduplication',
  'kg.settings.options.sourceStatus.draft': 'Draft',
  'kg.settings.options.sourceStatus.active': 'Active',
  'kg.settings.blocks.basic.title': 'Default entry behavior',
  'kg.settings.blocks.basic.description':
    'Define the default expand behavior and query context when entering the graph workspace.',
  'kg.settings.blocks.display.title': 'Canvas visibility',
  'kg.settings.blocks.display.description':
    'These settings control default visibility for nodes, relations, and property summaries.',
  'kg.settings.blocks.extraction.title': 'Extraction execution policy',
  'kg.settings.blocks.extraction.description':
    'Control post-import recognition, approval thresholds, and risk interception.',
  'kg.settings.blocks.governance.title': 'Governance execution policy',
  'kg.settings.blocks.governance.description':
    'Manage defaults for deduplication, import batches, and built-in capability protection.',
  'kg.settings.help.autoExpandRelatedEntities':
    'When enabled, entity detail and default graph views expand first-degree related nodes by default.',
  'kg.settings.help.showRelationLabels':
    'When disabled, relation text stays collapsed until the relation is focused or selected.',
  'kg.settings.help.enableNodeAggregation':
    'Aggregate similar nodes to reduce noise during initial rendering of large graphs.',
  'kg.settings.help.showPropertySummary':
    'Show a concise summary of key properties in the node side panel by default.',
  'kg.settings.help.highlightPathOnHover':
    'Highlight upstream and downstream paths when hovering nodes or relations.',
  'kg.settings.help.autoExtractOnImport':
    'Automatically enter the AI extraction flow as soon as an import task completes.',
  'kg.settings.help.requireManualReview':
    'Results that do not meet the auto-approve threshold must enter the manual review queue.',
  'kg.settings.help.enableRiskBlocking':
    'Add extra interception for risky relations and sensitive field changes.',
  'kg.settings.help.enableChangeAudit':
    'Record who changed a critical setting, when, and what was changed.',
  'kg.settings.help.lockSystemTypes':
    'Prevent built-in entity types and relation types from being modified casually.',
};
